
import React from 'react';
import { MapPin } from 'lucide-react';

export interface DeliveryAddressDetails {
  fullName: string;
  phoneNumber: string;
  address: string;
  city: string;
  postalCode?: string;
}

interface AddressDetailsProps {
  addressJson: string | null;
}

const AddressDetails = ({ addressJson }: AddressDetailsProps) => {
  // Helper function to parse delivery address JSON
  const parseDeliveryAddress = (addressJson: string | null): DeliveryAddressDetails | null => {
    if (!addressJson) return null;
    
    try {
      return JSON.parse(addressJson) as DeliveryAddressDetails;
    } catch (e) {
      console.error('Error parsing address:', e);
      return null;
    }
  };
  
  const addressDetails = parseDeliveryAddress(addressJson);
  
  if (!addressDetails) return null;
  
  return (
    <div className="bg-gray-50 dark:bg-gray-800 p-3 rounded-md">
      <h4 className="font-medium text-sm mb-2 flex items-center">
        <MapPin className="h-3.5 w-3.5 mr-1.5" />
        Detajet e Dorëzimit
      </h4>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm">
        <p><span className="font-medium">Emri:</span> {addressDetails.fullName}</p>
        <p><span className="font-medium">Nr. Tel:</span> {addressDetails.phoneNumber}</p>
        <p><span className="font-medium">Adresa:</span> {addressDetails.address}</p>
        <p><span className="font-medium">Qyteti:</span> {addressDetails.city} {addressDetails.postalCode || ''}</p>
      </div>
    </div>
  );
};

export default AddressDetails;
